import React from "react";
import PropTypes from "prop-types";
import styles from "./studioInfoModule.module.css";
import {connect} from "react-redux";
import {userMenuStore} from "./../../global/userMenuModule/userMenu";
import SectionToggle from "./../../../components/sectionToggle/sectionToggle";
import {actionCreators} from "./redux/sagas/studioInfo/studioInfo";
import MembershipActivityRevenueTable from "./smartComponents/membershipActivityRevenueTable";
import SalesActivityRevenueTable from "./smartComponents/salesActivityRevenueTable";
import SalesActivityPieChart from "./smartComponents/SalesActivityPieChart";
import MembershipActivityPieChart from "./smartComponents/membershipActivityPieChart";
import AverageEFT from "./smartComponents/averageEFT";
import Forecasted from "./smartComponents/forecasted";
import BookingsBreakdownComposedChart from "./smartComponents/bookingsBreakdownComposedChart";
import AttritionRateCallout from "./smartComponents/attritionRateCallout";
import Bookings from "./smartComponents/bookings";
import CustomDateRange from "./smartComponents/customDateRange";
import DatePicker from "./smartComponents/datePicker";

export class StudioInfoModule extends React.Component {
  state = {
    lightTheme: null
  };

  componentDidMount() {
    this.props.fetchCurrentUser(this.props.currentUser);
    if (this.props.currentUser.theme === "light") {
      this.setState({
        lightTheme: true
      });
    }
    userMenuStore.subscribe(() => {
      let userMenuState = userMenuStore.getState();
      this.setState({
        lightTheme: userMenuState.userMenu.lightTheme
      });
    });
  }

  resetData = () => {
    this.props.fetchCurrentUser(this.props.currentUser);
    this.setState({
      filtersDirty: false
    });
  };

  content() {
    return (
      <div>
        <div className="flex flex-col">
          <div className="edit-selections-bar" style={{height: "150px"}}>
            <div>
              <div className="select-box">
                <p className="offers-title">Date Range</p>
                {!this.state.filtersDirty && <CustomDateRange/>}
              </div>
              <div className="date-select-box select-box multi">
                <p className="offers-title">Date</p>
                {!this.state.filtersDirty && <DatePicker/>}
              </div>
            </div>
            <div>
              {this.props.filtersDirty &
              !this.props.isLoading &
              (this.props.selectedRequestDates.startDate !== "Invalid date") &
              (this.props.selectedRequestDates.endDate !== "Invalid date") ? (
                <button className="submit" onClick={() => this.props.updateAllData()}>
                  Update
                </button>
              ) : null}
              {this.props.filtersDirty && !this.props.isLoading ? (
                <button className="submit reset" onClick={() => this.resetData()}>
                  Reset
                </button>
              ) : null}
            </div>
          </div>
        </div>
        <div
          className={`${styles.container} ${styles.topContentContainer} ${this.state.lightTheme && styles.lightTopContainer}`}>
          <div className={`${styles.sectionGroup} ${styles.paddingRight}`}>
            <AverageEFT/>
          </div>
          <div className={`${styles.sectionGroup}`}>
            <Forecasted/>
          </div>
        </div>
        <div className={`${styles.container} ${this.state.lightTheme && styles.lightContainer}`} id="studioInfoReportContainer">
          <div className={`${styles.sectionGroup} ${styles.paddingRight}`}>
            <h2 className={`${styles.title}`}>Membership Activity</h2>
            <span className={`${styles.pieChartWrapper} ${this.state.lightTheme && styles.pieChartWrapperLight}`}>
              <MembershipActivityPieChart/>
            </span>
            <div className={`studio-info-table-wrapper ${styles.tableWrapper}`}>
              {this.props.membershipActivityTableInfo.length > 0 ?
                <MembershipActivityRevenueTable/>:
                <div className="error--medium">No revenue for selected date range</div>
              }
            </div>
            <AttritionRateCallout/>
          </div>
          <div className={`${styles.sectionGroup}`}>
            <h2 className={`${styles.title}`}>Sales Breakdown</h2>
            <span className={`${styles.pieChartWrapper} ${this.state.lightTheme && styles.pieChartWrapperLight}`}>
              <SalesActivityPieChart/>
            </span>
            <div className={`studio-info-table-wrapper ${styles.tableWrapper}`}>
              {this.props.salesActivityTableInfo.length > 0 ?
                <SalesActivityRevenueTable/> :
                <div className="error--medium">No revenue for selected date range</div>
              }
            </div>
          </div>
        </div>
        <div className={`${styles.container} ${this.state.lightTheme && styles.lightContainer}`}>
          <Bookings lightTheme={this.state.lightTheme}/>
        </div>
        <div
          className={`${styles.container} ${styles.paddingBottom} ${this.state.lightTheme && styles.lightContainer}`}>
          <BookingsBreakdownComposedChart/>
        </div>
      </div>
    );
  }

  render() {
    return (
      <SectionToggle
        hideToggle
        autoHeight
        title="Studio Info"
        customClass="studioInfoWidget"
        isLoading={this.props.isLoading}
        content={this.content()}
      />
    );
  }
}

export default connect(
  state => ({
    isLoading: state.studioInfo.isLoading,
    userParams: state.studioInfo.currentUser,
    filtersDirty: state.studioInfo.filtersDirty,
    selectedRequestDates: state.studioInfo.selectedRequestDates,
    salesActivityTableInfo: state.studioInfo.salesActivityRevenue.tableInfo.data,
    membershipActivityTableInfo: state.studioInfo.membershipActivityRevenue.tableInfo.data
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(StudioInfoModule);

StudioInfoModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  filtersDirty: PropTypes.bool,
  selectedRequestDates: PropTypes.object,
  salesActivityTableInfo: PropTypes.array,
  membershipActivityTableInfo: PropTypes.array,
};
